<template lang="html">
  <div>
    <b-container class="quotation-header-box">
      <b-row>
        <h1 class="breadcrumb-header">{{$t('profileMenu.links.eQuote.updateEQuote')}}</h1>
      </b-row>
    </b-container>
    <b-container class="quotation-breadcrumb-box">
      <b-row>
        <!-- <b-breadcrumb :items="items" class="breadcrumb-links"></b-breadcrumb> -->
        <b-breadcrumb class="breadcrumb-links">
          <b-breadcrumb-item href="../">{{$t('nav.home')}}</b-breadcrumb-item>
          <b-breadcrumb-item>{{$t('profileMenu.links.eQuote.title')}}</b-breadcrumb-item>
          <b-breadcrumb-item active>{{$t('profileMenu.links.eQuote.updateEQuote')}}</b-breadcrumb-item>
        </b-breadcrumb>
      </b-row>
    </b-container>
  </div>
</template>
<script lang="js">
export default {
  name: 'QuotationBreadcrumb',
  data() {
      return {
        // items: [
        //   {
        //     text: 'Home',
        //     href: '../'
        //   },
        //   {
        //     text: 'E-Quote',
        //   },
        //   {
        //     text: 'New E-Quote',
        //     active: true
        //   }
        // ]
      }
    }
}
</script>
<style lang="css" scoped>
.quotation-breadcrumb-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10vh !important;
}
.quotation-header-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.breadcrumb-links {
  background-color: #fff !important;
}
.breadcrumb-links li:last-child {
  font-weight: 600;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: ">"
}
.breadcrumb-item.active {
  color: #082139 !important;
}
li:not(.breadcrumb-item.active) {
  color: #6c757d !important;
}
.breadcrumb-header {
  color: #082139 !important;
}
</style>